/**
 * @ngdoc StringUtils
 * @name StringUtils
 *
 */
class StringUtils {

    /**
     * @description
     */
    static toCamelCase(string) {
        // Lower cases the string.
        const transformed = string
            // Adding space in front of every capital letter.
            .replace(/([A-Z])/g, ' $1')
            // Lowers case of all letters.
            .toLowerCase()
            // Replaces any - or _ characters with a space.
            .replace(/[-_]+/g, ' ')
            // Removes any non alphanumeric characters expect ':' (left for marking comments).
            .replace(/[^\w\s:]/g, '')
            // Uppercases the first character in each group immediately following a space (delimited by spaces).
            .replace(/ (.)/g, $1 => $1.toUpperCase())
            // Removes spaces.
            .replace(/ /g, '' );

        // Make sure first letter is a lowered.
        return transformed.charAt(0).toLowerCase() + transformed.slice(1);
    }

}

export { StringUtils };


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_functions/strings.js